<template>
  <v-container class="pt-5">
    <h1>Ikonki używane w widoku</h1>
    <custom-container class="mx-0">
      <h2>Generic</h2>
      <div v-for="(value, name, index) of generic" :key="index" class="d-inline-block text-center ma-4">
        <div>
          <v-icon x-large color="red">${{ name }}</v-icon>
        </div>
        ${{ name }}
      </div>
      <h2>Notification</h2>
      <div v-for="(value, name, index) of notification" :key="index" class="d-inline-block text-center ma-4">
        <div>
          <v-icon x-large color="red">${{ name }}</v-icon>
        </div>
        ${{ name }}
      </div>
    </custom-container>
  </v-container>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";
import CustomContainer from "@/components/shared/layout/CustomContainer.vue";
import { genericIcons, notificationStatusIcons } from "@/components/shared/icons/iconfont";
@Component({
  components: { CustomContainer },
})
export default class IconsView extends Vue {
  generic = genericIcons;
  notification = notificationStatusIcons;
}
</script>

<style scoped></style>
